import { makeStyles } from "@material-ui/core"

type StyleProps = { minHeight: number }

const useStyles = makeStyles({
	root: {
		"& .MuiInputBase-inputMultiline": {
			minHeight: ({ minHeight }: StyleProps) => minHeight,
			resize: "vertical",
			fontFamily: "inherit",
			fontSize: 14
		}
	}
})

export default useStyles
